import {
    Alert,
    AlertTitle,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Stack,
    TextField,
    Typography,
  } from "@mui/material";
  import { useState } from "react";
  import { useTranslation, Trans } from "react-i18next";
  import VerifiedIcon from "@mui/icons-material/Verified";
  import { createUser } from "../models/users";
  import { validateEmail, validateUsername } from "../utils";
  import { useSignMessage } from "wagmi";
  
  export default function AlertVerify() {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
  
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
  
    return (
      <div>
        <Alert
          // icon={<img src="/img/n2w_transparent.svg" height={36} />}
          severity="warning"
          action={
            <Button onClick={handleClickOpen} variant="contained">
              <Trans t={t}>Verify</Trans>
            </Button>
          }
        >
          <AlertTitle>
            <Trans t={t}>Earn $N2W</Trans>
          </AlertTitle>
          <Trans t={t}>
            Verify your wallet and start earning $N2W with every bet.
          </Trans>
        </Alert>
        <VerifyDialog open={open} onClose={handleClose} />
      </div>
    );
  }
  
  function VerifyDialog(props) {
    const { t } = useTranslation();
    const { onClose, selectedValue, open } = props;
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
  
    const { signMessage } = useSignMessage({
      message: "nice2win",
      onSettled: async function (data, error) {        
        if (error) {
          setError(error.message);
          return;
        }
        const sent = await createUser(data, email, username);
        const successMessage = `${t("Verification email sent to ")} ${email}. ${t(
          "Please refresh the page after verifying."
        )}`;
        setSuccess(successMessage);        
      },
    });
  
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const handleEmailChange = (event) => {
      setEmail(event.target.value);
    };
    const handleUsernameChange = (event) => {
      setUsername(event.target.value);
    };
  
    const handleClose = () => {
      onClose(selectedValue);
    };
  
    async function handleVerifyClick() {
      try {
        setError("");
        if (!email) throw new Error(t("Missing email address"));
        if (!validateEmail(email)) throw new Error(t("Invalid email address"));
        if (!username) throw new Error(t("Missing username"));
        if (!validateUsername(username)) throw new Error(t("Invalid username"));
        signMessage();
      } catch (err) {
        setError(err.message);
      }
    }
  
    return (
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>
          <Trans t={t}>Sign up to earn $NW2</Trans>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={4}>
            <Alert severity="info" icon={<VerifiedIcon color="info" />}>
              <AlertTitle>
                <Trans t={t}>One step away</Trans>
              </AlertTitle>
              <p>
                <Trans t={t}>
                  You will need to sign a message with your wallet to verify your
                  address. A valid email address is required.
                </Trans>
              </p>
            </Alert>
            {error && <Alert severity="error">{error}</Alert>}
            {success && <Alert severity="success">{success}</Alert>}
            <TextField
              label="*Email"
              value={email}
              onChange={handleEmailChange}
            />
            <Stack>
              <TextField
                label="*Username"
                value={username}
                onChange={handleUsernameChange}
              />
              <Typography color="secondary">
                <Trans t={t}>*maximum 15 characters</Trans>
              </Typography>
            </Stack>
            <Stack
              spacing={1}
              direction="row"
              sx={{ justifyContent: "flex-end" }}
            >
              <Button onClick={handleClose}>
                <Trans t={t}>Cancel</Trans>
              </Button>
              <Button onClick={handleVerifyClick} variant="contained">
                <Trans t={t}>Verify</Trans>
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog>
    );
  }
  